export const vendorListRecurringWorkORder = [
    {
        value: 'Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072',
        label: <p><i className="fa-sharp fa-solid fa-user-gear"></i> Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072</p>,
    },
    {
        value: 'A New Creation L.L.C. - 11711 Lorene Ave Midwest City, OK 73130',
        label: <p><i className="fa-sharp fa-solid fa-user-gear"></i> A New Creation L.L.C. - 11711 Lorene Ave Midwest City, OK 73130</p>,
    },
    {
        value: 'AT&amp;T - PO Box 5014 Carol Stream, IL 60197',
        label: <p><i className="fa-sharp fa-solid fa-user-gear"></i> AT&amp;T - PO Box 5014 Carol Stream, IL 60197</p>,
    },
    {
        value: 'Anthonys appliance - appliance service',
        label: <p><i className="fa-sharp fa-solid fa-user-gear"></i> Anthonys appliance - appliance service</p>,
    },
    {
        value: 'Adams Appliance Repair - 7712 NW 3rd Suilte D Oklahoma City, OK 73127',
        label: <p> <i className="fa-sharp fa-solid fa-user-gear"></i> Adams Appliance Repair - 7712 NW 3rd Suilte D Oklahoma City, OK 73127</p>,
    },
    {
        value: 'Adhyas Avasthi',
        label: <p><i className="fa-sharp fa-solid fa-user-gear"></i> Adhyas Avasthi</p>,
    },
    {
        value: 'Brothers and Sons Heat and Air - PO Box 484 Crescent, OK 73028',
        label: <p><i className="fa-sharp fa-solid fa-user-gear"></i> Brothers and Sons Heat and Air - PO Box 484 Crescent, OK 73028</p>,
    },
]

export const recWOTableData = [
    {
        key: "1",
        id: 1,
        vendor: "--",
        property: "	GF3, Block 58, Seaview Apartments, DHA Phase 5",
        repeats: "Monthly",
        description: "--",
        recurrenceInformation: {
            startOn: "02/28/2023",
            endOn: "--",
            frequency: "This work order recurs the 1st of every month."
        },
        propertyInformation: {
            properties: "GF3, Block 58, Seaview Apartments, DHA Phase 5",
            maintenanceLimit: "--",
            unit: "--",
            maintenanceNotes: "--",
            creationStyle: "Per Property",
        },
        workOrderInformation: {
            description: "--",
            vendorInstructions: "--",

        },
        vendorInformation: {
            vendor: "No vendor specified.",
            assignedUser: "No user assigned.",
            phoneNumber: "051-75886",
            email: "seeratkhan@gmail",
            address: "Noorabad Colony"
        },
        billingInformation: [
            {
                account: "--",
                statementDescription: "--",
                amount: "0.00"
            },
        ],
    },
];

export const repeats = [
    {
        value: "Monthly"
    },
    {
        value: "Weekly"
    },
    {
        value: "Bi-Weekly"
    },
    {
        value: "On Move In"
    },
    {
        value: "On Move Out"
    },
    {
        value: "Never (Must Post Manually)"
    },
];

export const properties = [
    {
        value: "Test 1"
    },
    {
        value: "Test 2"
    },
    {
        value: "Test 3"
    },
    {
        value: "Test 4"
    },
];

export const vendors = [
    {
        value: "vendor 1"
    },
    {
        value: "vendor 2"
    },
    {
        value: "vendor 3"
    },
    {
        value: "vendor 4"
    },
];